import React from 'react'

export function BottomText (props) {
  return (
    <div className="sm:w-3/4 bottom-0 | py-8 | text-center">
      <span className="block left-0 | text-gray font-normal text-xs">{props.text}</span>
    </div>
  )
}
